import { AnimateHingeDoorsSystem, CoreApi } from '@inter-ikea-storageone/range';
import { e2e, getQuery } from 'utils/queryUtils';
import { Feature, RenderLocation, RendersComponent } from '../../../../features/Feature';
import { ToggleDoors, AnimateDoors } from './ToggleDoors';

const enableAnimations = getQuery().get('enableAnimations') === 'true';

export class ToggleDoorsFeature extends Feature implements RendersComponent {
  protected init(coreApi: CoreApi): void {
    if (enableAnimations) {
      coreApi.registerSystem(new AnimateHingeDoorsSystem(coreApi));
    }
  }

  render(location: RenderLocation) {
    if (location !== RenderLocation.Root) return;

    if (enableAnimations && !e2e()) {
      return AnimateDoors;
    }

    return ToggleDoors;
  }
}
